import { useEffect, useState } from 'react';

export type DayKey = 'weekday' | 'weekend' | 'sunday';

interface OpenShift {
  open: number;
  close: number;
}

// Minute od polnoči. Zaprtje po polnoči je izraženo kot > 1440 (npr. 03:00 => 1620).
const schedule: Record<number, OpenShift[]> = {
  0: [{ open: 9 * 60, close: 22 * 60 }], // Nedelja
  1: [{ open: 6 * 60 + 30, close: 23 * 60 }], // Ponedeljek
  2: [{ open: 6 * 60 + 30, close: 23 * 60 }], // Torek
  3: [{ open: 6 * 60 + 30, close: 23 * 60 }], // Sreda
  4: [{ open: 6 * 60 + 30, close: 23 * 60 }], // Četrtek
  5: [{ open: 7 * 60, close: 27 * 60 }], // Petek (do 03:00)
  6: [{ open: 7 * 60, close: 27 * 60 }], // Sobota (do 03:00)
};

function getDayKey(date: Date): DayKey {
  const day = date.getDay();
  if (day === 0) return 'sunday';
  if (day === 5 || day === 6) return 'weekend';
  return 'weekday';
}

function computeIsOpen(date: Date): boolean {
  const day = date.getDay();
  const minutes = date.getHours() * 60 + date.getMinutes();

  const today = schedule[day] ?? [];
  for (const shift of today) {
    if (minutes >= shift.open && minutes < shift.close) return true;
  }

  // Preveri tudi izmeno prejšnjega dne, ki traja po polnoči.
  const prevDay = (day + 6) % 7;
  const prev = schedule[prevDay] ?? [];
  for (const shift of prev) {
    if (shift.close > 24 * 60 && minutes + 24 * 60 < shift.close) return true;
  }

  return false;
}

export default function useOpenStatus() {
  const [isOpen, setIsOpen] = useState(() => computeIsOpen(new Date()));
  const [dayKey, setDayKey] = useState<DayKey>(() => getDayKey(new Date()));

  useEffect(() => {
    const tick = () => {
      const now = new Date();
      setIsOpen(computeIsOpen(now));
      setDayKey(getDayKey(now));
    };

    tick();
    const timer = window.setInterval(tick, 60000);
    return () => window.clearInterval(timer);
  }, []);

  return { isOpen, dayKey };
}